



























import { defineComponent, computed, onMounted, useContext } from '@nuxtjs/composition-api';
import { useCurrentUser, useTranslations, useWishlist } from '@vue-storefront/novulo';
import useUrlFormatter from '~/hooks/useUrlFormatter';
import useWindowResize from '~/hooks/useResizeWindow';

export default defineComponent({
  name: 'MoleculesWishlistButton',
  setup: () => {
    const { currentUser, getCurrentUser, getUserToken } = useCurrentUser();
    const { wishlist, getWishlist } = useWishlist();
    const { translate } = useTranslations();
    const { isDesktop } = useWindowResize();
    const formatUrl = useUrlFormatter();
    const context = useContext();

    const itemsCount = computed<number>(() => wishlist.value?.length ?? 0);

    // fix: remove leading slash from the i18n key
    const loginUrl = formatUrl((context.i18n.t('login_url') as string) || '/');
    const wishlistUrl = formatUrl((context.i18n.t('/wishlist_url') as string) || '/');

    let isNavigating = false;

    const handleClick = async () => {
      if (isNavigating) return;
      isNavigating = true;

      try {
        const token = getUserToken();
        if (token) {
          try {
            await getCurrentUser();
          } catch { /* silent */ }
        }
      } finally {
        window.location.href = currentUser.value ? wishlistUrl : loginUrl;
      }
    };

    onMounted(async () => {
      if (!Array.isArray(wishlist.value)) {
        try {
          await getWishlist();
        } catch { /* silent */ }
      }
    });

    return { isDesktop, itemsCount, handleClick, translate };
  }
});
